(function(){
  function esc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML;}
  function rev(){
    var a=document.querySelector('[data-zp-rev]');
    if(!a||a.__r)return;a.__r=1;
    a.addEventListener('click',function(e){
      var t=document.getElementById('zp-reviews')||document.querySelector('.zm-reviews-wrap')||document.getElementById('judgeme_product_reviews');
      if(!t)return;
      e.preventDefault();
      var y=t.getBoundingClientRect().top+window.pageYOffset-70;
      window.scrollTo({top:y,behavior:'smooth'});
    });
  }
  function pick(root){
    var picks=[];
    [].slice.call(root.querySelectorAll('.jdgm-rev')).forEach(function(r){
      if(picks.length>=5)return;
      var sc=r.querySelector('.jdgm-rev__rating');
      var score=sc?+(sc.getAttribute('data-score')||0):0;
      var b=r.querySelector('.jdgm-rev__body'),au=r.querySelector('.jdgm-rev__author');
      var txt=b?b.textContent.trim():'';
      if(score>=4&&txt.length>20&&au){
        if(txt.length>180)txt=txt.slice(0,177).replace(/\s+\S*$/,'')+'…';
        picks.push({a:au.textContent.trim(),t:txt,v:r.getAttribute('data-verified-buyer')==='true'});
      }
    });
    return picks;
  }
  function render(box,picks){
    box.innerHTML=picks.map(function(p,i){
      return '<figure class="ev-sw'+(i?'':' on')+'"><div class="ev-rh"><span class="av"></span><div><b>'+esc(p.a)+(p.v?'<u>&#10003;</u>':'')+'</b><span class="st">★★★★★</span></div></div><blockquote>'+esc(p.t)+'</blockquote></figure>';
    }).join('');
    box.hidden=false;
    var sl=[].slice.call(box.querySelectorAll('.ev-sw')),si=0,paused=false;
    if(sl.length>1&&!(window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches)){
      box.addEventListener('mouseenter',function(){paused=true;});
      box.addEventListener('mouseleave',function(){paused=false;});
      setInterval(function(){if(paused||document.hidden)return;sl[si].classList.remove('on');si=(si+1)%sl.length;sl[si].classList.add('on');},4500);
    }
  }
  function auto(){
    var box=document.querySelector('[data-ev-auto]');
    if(!box||box.__a)return;box.__a=1;
    var done=false;
    function fin(p){if(done||!p.length)return;done=true;render(box,p);}
    var tries=0,iv=setInterval(function(){
      tries++;
      fin(pick(document));
      if(done||tries>40)clearInterval(iv);
    },500);
    var pid=box.getAttribute('data-pid');
    if(pid){
      var dom=location.hostname;
      var u='https://judge.me/reviews/reviews_for_widget?url='+encodeURIComponent(dom)+'&shop_domain='+encodeURIComponent((window.Shopify&&Shopify.shop)||dom)+'&platform=shopify&product_id='+pid+'&per_page=10&page=1&sort_by=highest_rating';
      fetch(u).then(function(r){return r.json();}).then(function(j){
        if(!j||!j.html)return;
        var d=document.createElement('div');d.innerHTML=j.html;
        fin(pick(d));
      }).catch(function(){});
    }
  }
  function go(){rev();auto();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();